import { Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import useStyles from './useStyles'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import SyncIcon from '@mui/icons-material/Sync'
import { BasicEnabledME } from '../../../../components/Modals/Instances/Modules/Organization/BasicEnabledME'

export const BoxDetails = ({ dataprocess = null, organization }) => {
  const classes = useStyles()
  const [openModal, setopenModal] = useState(false)

  const handleClose = () => {
    setopenModal(false)
  }

  return (
    <>
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Detalles del estado de la Organización
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Grid container style={{ padding: 10 }}>
            <Grid item xs={6}>
              <Typography
                style={{
                  fontSize: 14,
                  fontWeight: 'bold',
                  color: '#485450'
                }}
              >
                Existe el Estudio:
              </Typography>
            </Grid>
            <Grid item xs={6}>
              {dataprocess?.data?.suborganizationExist
                ? (
                <CheckCircleIcon
                  style={{ fontSize: '2rem', color: '#00a78f' }}
                />
                  )
                : (
                <CancelIcon style={{ fontSize: '2rem', color: '#AD0707' }} />
                  )}
            </Grid>
          </Grid>
          <Grid container style={{ padding: 10 }}>
            <Grid item xs={6}>
              <Typography
                style={{
                  fontSize: 14,
                  fontWeight: 'bold',
                  color: '#485450'
                }}
              >
                Existe el suscriptor en Mi Errepar:
              </Typography>
            </Grid>
            <Grid item xs={6}>
              {dataprocess?.data?.subscriberExist
                ? (
                <CheckCircleIcon
                  style={{ fontSize: '2rem', color: '#00a78f' }}
                />
                  )
                : (
                <CancelIcon style={{ fontSize: '2rem', color: '#AD0707' }} />
                  )}
            </Grid>
          </Grid>
          <Grid container style={{ padding: 10 }}>
            <Grid item xs={6}>
              <Typography
                style={{
                  fontSize: 14,
                  fontWeight: 'bold',
                  color: '#485450'
                }}
              >
                Existe la carpeta de sistema base:
              </Typography>
            </Grid>
            <Grid item xs={6}>
              {dataprocess?.data?.baseSystemDefinedDirStorageExist
                ? (
                <CheckCircleIcon
                  style={{ fontSize: '2rem', color: '#00a78f' }}
                />
                  )
                : (
                <>
                  <CancelIcon style={{ fontSize: '2rem', color: '#AD0707' }} />
                </>
                  )}
            </Grid>
          </Grid>
          <Grid container style={{ padding: 10 }}>
            <Grid item xs={6}>
              <Typography
                style={{
                  fontSize: 14,
                  fontWeight: 'bold',
                  color: '#485450'
                }}
              >
                Existe la Instancia de la aplicación:
              </Typography>
            </Grid>
            <Grid item xs={6}>
              {dataprocess?.data?.applicationInstanceExist
                ? (
                <CheckCircleIcon
                  style={{ fontSize: '2rem', color: '#00a78f' }}
                />
                  )
                : (
                <CancelIcon style={{ fontSize: '2rem', color: '#AD0707' }} />
                  )}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            borderLeft: '2px solid rgba(36, 55, 143, 0.2)'
          }}
        >
          <div
            style={{
              display: 'inline-block',
              color: '#00a78f',
              cursor: 'pointer'
            }}
            onClick={() => setopenModal(true)}
          >
            <SyncIcon />
            <Typography style={{ fontWeight: 'bold' }}>
              Volver a inicializar
            </Typography>
          </div>
        </Grid>
      </Grid>
      <BasicEnabledME
        openModal={openModal}
        handleClose={handleClose}
        organization={organization}
      />
    </>
  )
}
